/* Common Pages */
export const SUPPORT_KEY_DASHBOARD = 'SUPPORT_KEY_DASHBOARD';
export const SUPPORT_KEY_ACCOUNT = 'SUPPORT_KEY_ACCOUNT';
export const SUPPORT_KEY_CREDENTIAL = 'SUPPORT_KEY_CREDENTIAL';
export const SUPPORT_KEY_LOOKUP = 'SUPPORT_KEY_LOOKUP';
export const SUPPORT_KEY_LINEAGE = 'SUPPORT_KEY_LINEAGE';
export const SUPPORT_KEY_NOTIFICATION = 'SUPPORT_KEY_NOTIFICATION';
export const SUPPORT_KEY_REUSABLE_TX = 'SUPPORT_KEY_REUSABLE_TX';
export const SUPPORT_KEY_QUARANTINE = 'SUPPORT_KEY_QUARANTINE';
export const SUPPORT_KEY_SCHEMA_SPEC = 'SUPPORT_KEY_SCHEMA_SPEC';
export const SUPPORT_KEY_API_KEY = 'SUPPORT_KEY_API_KEY';

/* Data Flows */
export const SUPPORT_KEY_FLOW_LIST = 'SUPPORT_KEY_FLOW_LIST';
export const SUPPORT_KEY_FLOW_CREATE = 'SUPPORT_KEY_FLOW_CREATE';

/* Source List and Creation */
export const SUPPORT_KEY_SOURCE_LIST_VIEW = 'SUPPORT_KEY_SOURCE_LIST_VIEW';
export const SUPPORT_KEY_SOURCE_FORM_COMMON = 'SUPPORT_KEY_SOURCE_FORM_COMMON';
export const SUPPORT_KEY_SOURCE_FORM_SELECT = 'SUPPORT_KEY_SOURCE_FORM_SELECT';
export const SUPPORT_KEY_SOURCE_FORM_DB = 'SUPPORT_KEY_SOURCE_FORM_DB';
export const SUPPORT_KEY_SOURCE_FORM_NOSQL = 'SUPPORT_KEY_SOURCE_FORM_NOSQL';
export const SUPPORT_KEY_SOURCE_FORM_EMAIL = 'SUPPORT_KEY_SOURCE_FORM_EMAIL';
export const SUPPORT_KEY_SOURCE_FORM_FILE = 'SUPPORT_KEY_SOURCE_FORM_FILE';
export const SUPPORT_KEY_SOURCE_FORM_REST = 'SUPPORT_KEY_SOURCE_FORM_REST';
export const SUPPORT_KEY_SOURCE_FORM_REST_TEMP = 'SUPPORT_KEY_SOURCE_FORM_REST_TEMP';
export const SUPPORT_KEY_SOURCE_FORM_WEBHOOK = 'SUPPORT_KEY_SOURCE_FORM_WEBHOOK';

/* Nexset List and Creation */
export const SUPPORT_KEY_DATASET_LIST = 'SUPPORT_KEY_DATASET_LIST';
export const SUPPORT_KEY_DATASET_FORM_TX = 'SUPPORT_KEY_DATASET_FORM_TX';

/* Destination List and Creation */
export const SUPPORT_KEY_SINK_LIST = 'SUPPORT_KEY_SINK_LIST';
export const SUPPORT_KEY_SINK_FORM_COMMON = 'SUPPORT_KEY_SINK_FORM_COMMON';
export const SUPPORT_KEY_SINK_FORM_SELECT = 'SUPPORT_KEY_SINK_FORM_SELECT';
export const SUPPORT_KEY_SINK_FORM_DB = 'SUPPORT_KEY_SINK_FORM_DB';
export const SUPPORT_KEY_SINK_FORM_FILE = 'SUPPORT_KEY_SINK_FORM_FILE';
export const SUPPORT_KEY_SINK_FORM_REST = 'SUPPORT_KEY_SINK_FORM_REST';
export const SUPPORT_KEY_SINK_FORM_REST_TEMP = 'SUPPORT_KEY_SINK_FORM_REST_TEMP';
export const SUPPORT_KEY_SINK_FORM_DYN_LUP = 'SUPPORT_KEY_SINK_FORM_DYN_LUP';
export const SUPPORT_KEY_SINK_FORM_NOSQL = 'SUPPORT_KEY_SINK_FORM_NOSQL';
